import { createStore } from 'vuex'

export default createStore({
  state: {
    sections: {
      lougaVoyages: [],
      saveursNDeco: [],
      lamienConsulting: [],
      cliniqueDemAssi: []
    }
  },
  mutations: {
    setSectionData(state, { section, data }) {
      state.sections[section] = data
    }
  },
  actions: {
    fetchSectionData() { 
      // Appel API pour récupérer les infos
      // commit('setSectionData', { section, data })
    }
  },
  getters: {
    getSection: (state) => (section) => state.sections[section]
  }
})